module.exports = __webpack_public_path__ + "img/3.767b624.png";